import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, delay, ease }} className={className}>
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, accent, testid }) => (
  <Reveal className="mb-14 max-w-4xl sm:mb-20">
    <p className="eyebrow mb-5">{eyebrow}</p>
    <h2 className="font-display text-3xl font-black uppercase leading-[1] tracking-[-0.02em] text-white sm:text-5xl lg:text-6xl" data-testid={testid}>
      {title} <span className="text-[#00E676]">{accent}</span>
    </h2>
  </Reveal>
);
